/*
 * This file contains a skeleton loader for the floorplan component.
 */

import clsx from "clsx";
import styles from "../../floorplans.module.scss";
import skeltonStyle from "./floorplansSkelton.module.scss";
import FloorplanCardSkelton from "./floorplanCardSkelton";

export default function FloorplanSkelton({ activeTab = "grid", typeListing = true }) {
  return (
    <div className={styles.FloorplanSkeltonContainer}>
      {/* Hero section skeleton for unit listing */}
      {!typeListing && activeTab === "list" && (
        <>
          <p className={clsx(styles.InnerNav, skeltonStyle.skeleton, skeltonStyle.breadcrumb)}></p>
          <h2 className={clsx(styles.FloorplanName, skeltonStyle.skeleton, skeltonStyle.floorplanTitle)}></h2>
          <ul className={styles.FloorplanChips}>
            <li className={clsx(skeltonStyle.skeleton, skeltonStyle.chipSkeleton)}></li>
            <li className={clsx(skeltonStyle.skeleton, skeltonStyle.chipSkeleton)}></li>
          </ul>
          <div className={styles.FloorplanHero}>
            <div className={styles.FloorplanImageSection}>
              <div className={clsx(styles.AvailabilityBadge, skeltonStyle.skeleton, skeltonStyle.availabilityBadge)}></div>
              <div className={styles.FloorplanImageWrapper}>
                <div className={clsx(skeltonStyle.skeleton, skeltonStyle.heroImage)}></div>
              </div>
              <p className={clsx(styles.ImageDisclaimer, skeltonStyle.skeleton, skeltonStyle.disclaimer)}></p>
            </div>
            <div className={clsx(styles.AmenitiesSection, skeltonStyle.amenitiesSectionSkeleton)}>
              <h3 className={clsx(skeltonStyle.skeleton, skeltonStyle.amenitiesTitle)}></h3>
              <ul>
                {Array.from({ length: 6 }, (_, index) => (
                  <li key={index} className={clsx(skeltonStyle.skeleton, skeltonStyle.amenityItem)}></li>
                ))}
              </ul>
            </div>
          </div>
        </>
      )}
      <p className={styles.ResultsCount}>Loading Results</p>
      <div
        className={clsx(
          activeTab === "grid" && styles.FloorplanGridContainer,
          activeTab === "list" && styles.FloorplanListContainer
        )}
      >
        {Array.from({ length: 12 }, (_, index) => (
          <FloorplanCardSkelton key={index} activeTab={activeTab} typeListing={typeListing} />
        ))}
      </div>
    </div>
  );
}
